import ReportsAnalystTable from "./ReportsAnalystTable";

const ReportsAnalyst = ({ TabConfig }) => {
  return <ReportsAnalystTable TabConfig={TabConfig} />;
};

export default ReportsAnalyst;
